import {ProcessSource} from "../models/process-source";

export class MainProcessSourceFilter {

    /**
     * Apply type filters
     * @param projects
     * @param filters
     */
    static apply(projects: ProcessSource[], filters: string[]): ProcessSource[] {
        if (!filters || filters.length === 0) {
            return projects;
        }
        // check if type filters included
        if (!filters.some((f) => f.includes("hpa-"))) {
            // no type filters
            return projects;
        }

        return projects.filter((p: ProcessSource) => {
            const key = `hpa-${p.mainProcessId}`;
            // show process source when filter key matches
            return filters.includes(key);
        });
    }
}
